/**
 * Created with IntelliJ IDEA.
 * User: danielr
 * Date: 8/24/14
 * Time: 4:52 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var GeneralUtils = {};

    LE.module('LEManager', function (LEManager, LE, Backbone, Marionette, $, _) {

        GeneralUtils = (function () {

            function duplicateCollection(collection) {
                return new collection.constructor(_.map(collection.models, function (m) {
                    return m.clone();
                }));
            }

            function objectDeepDelete(path, parent) {
                var items = path.split('.');

                if (items.length > 1){
                    if (!_.isUndefined(parent[items[0]])) {
                        objectDeepDelete(items.slice(1).join('.'), parent[items[0]]);
                    }
                    else {
                        LEManager.logger.error("GeneralUtils::objectDeepDelete - wrong delete path - " + path);
                        LEManager.logger.graph({name:"manager:GeneralUtils:objectDeepDelete:wrongPath"});
                        throw "GeneralUtils::objectDeepDelete - wrong delete path";
                    }
                }
                else {
                    delete parent[path];
                }
                if (items.length > 1 && _.isEmpty(parent[items[0]][items[1]])){
                    delete parent[items[0]][items[1]];
                }
            }

            return {
                duplicateCollection: duplicateCollection,
                objectDeepDelete: objectDeepDelete
            };
        })();
    });

    return GeneralUtils;
});
